.dialogHeader {
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.dialogBody {
	display: flex;
	flex-direction: column;
	width: 300px;
	padding: 0px 20px 20px 20px;
}

.icon {
	height: 48px;
	width: 48px;
}

.message {
	font-size: 12px;
	text-align: center;
	padding-right: var(--tl-space-4);
	margin-bottom: 24px;
	min-height: 20px;
	word-break: break-word;
	overflow-wrap: break-word;
}

.acceptButton {
	width: 100%;
	height: 32px;
	background-color: var(--tl-color-primary);
	color: var(--tl-color-selected-contrast);
	border: none;
	border-radius: var(--tl-radius-1);
	font-weight: 500;
	cursor: pointer;
}

.acceptButton:hover:not(:disabled) {
	background-color: var(--tla-color-primary-hover);
}

.acceptButton:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.declineButton {
	background: none;
	border: none;
	color: var(--tl-color-text-3);
	cursor: pointer;
	padding: var(--tl-space-3);
	height: 32px;
}

.declineButton:hover {
	color: var(--tl-color-text-0);
}
